import {FC} from 'react'
import clsx from 'clsx'
import {useLocation} from 'react-router'
// import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {checkIsActive, toAbsoluteUrl, WithChildren} from '../../../helpers'
import {useLayout} from '../../core'
import {Tooltip} from '@mui/material'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  bsTitle?: string
  heading?: string
  isMinified?: boolean
}

const AsideMenuItemWithSubMain: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet,
  bsTitle,
  heading,
  isMinified = false,
}) => {
  const {pathname} = useLocation()
  const isActive = checkIsActive(pathname, to)
  const {config} = useLayout()
  const {aside} = config

  return (
    <div
      className={clsx('menu-item py-3', {'here show': isActive})}
      data-kt-menu-trigger='click'
      data-kt-menu-placement='right-start'
    >
      <Tooltip
        title={
          isMinified ? (
            <h1 style={{fontSize: '12px', color: 'white', backgroundColor: 'transparent'}}>
              {heading}
            </h1>
          ) : (
            ''
          )
        }
        followCursor
        slotProps={{
          popper: {
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, -30],
                },
              },
            ],
          },
        }}
      >
        <span className='menu-link menu-center'>
          {fontIcon && aside.menuIcon === 'font' && (
            <span className='menu-icon me-0'>
              <i className={clsx('bi', fontIcon, 'fs-2')}></i>
            </span>
          )}
          {icon && aside.menuIcon === 'svg' && (
            <span className='menu-icon p-3'>
              <img src={toAbsoluteUrl(icon)} alt='' className=' img-fluid' />
            </span>
          )}
          {heading && isMinified === false && <span className='menu-text'>{heading}</span>}
        </span>
      </Tooltip>

      <div
        className={clsx('menu-sub menu-sub-dropdown w-225px w-lg-275px px-1 py-4', {
          'menu-active-bg': isActive,
        })}
      >
        {children}
      </div>
    </div>
  )
}

export {AsideMenuItemWithSubMain}
